import { API_DASHBOARD_ROUTE } from 'constants/api.constant';
import AxiosUtil from 'utils/axios.util';

const DashboardRepository = {
  getDashboard() {
    try {
      return AxiosUtil.get(
        { url: `${API_DASHBOARD_ROUTE}`, submitData: {} },
        (res) => {
          return res;
        },
        (err) => {
          console.error(err.message);
        },
      );
    } catch (err) {
      console.error(err.message);
    }
  },
};

export default DashboardRepository;
